import React from 'react'

/**
 * Modulo Mix Inteligente: alvo com a flecha acertando — a oportunidade de
 * cross-sell apontada ao cliente certo. (IconPark "trace".)
 */
export function ModuloMixIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="10.5" cy="13.5" r="8" stroke="#fff" strokeWidth="1.6" />
      <circle cx="10.5" cy="13.5" r="3.8" stroke="#fff" strokeWidth="1.6" />
      <circle cx="10.5" cy="13.5" r="1.2" fill="#fff" />
      <path
        d="M10.5 13.5L19.4 4.6"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M14.6 4.6h4.8v4.8"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
